import { render, staticRenderFns } from "./profitRep.vue?vue&type=template&id=07ec4a31&scoped=true&"
import script from "./profitRep.vue?vue&type=script&lang=js&"
export * from "./profitRep.vue?vue&type=script&lang=js&"
import style0 from "./profitRep.vue?vue&type=style&index=0&id=07ec4a31&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ec4a31",
  null
  
)

export default component.exports